import React from "react";

import ResponsiveTable from "../../../containers/responsive-table";
import Row from "../../../containers/responsive-table/row";
import TBody from "../../../containers/responsive-table/tbody";
import HeadCell from "../../../containers/responsive-table/head-cell";
import BodyCell from "../../../containers/responsive-table/body-cell";
import { decimalsRound } from "../../../services/utils";
import Thead from "../../../containers/responsive-table/thead";
import styled from 'styled-components';
import Fragment from 'react-dot-fragment';

const getBackgroundVariant = (value, itemRound, currentRound) => {
  if (itemRound === currentRound && value > 0) {
    return "highlighted";
  } else if (value <= 0) {
    return "disabled";
  } else {
    return "default";
  }
};

const TableWrapper = styled.div`
  padding: 20px;

  ${p => p.padding && `
    padding: ${p.padding};
  `}
`;

const TableHeaderText = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

const FinancialTargets = props => {
  const { round, financialTargets, hideTitle, padding, onHelpIconClick } = props;

  return (
    <TableWrapper padding={padding}>
      {!hideTitle && <TableHeaderText>Financial Metrics &amp; Targets</TableHeaderText>}
      <ResponsiveTable>
        <Thead>
          <Row>
            <HeadCell iconType="sort" cellSize="small">
              Year
            </HeadCell>
            {
              round < 3 &&
              <HeadCell iconType={"help"} onHelpIconClick={() => onHelpIconClick("Market Share")}>Market Share</HeadCell>
            }
            {
              round <= 3 &&
              <Fragment>
                <HeadCell iconType="help" onHelpIconClick={() => onHelpIconClick("Revenues")}>Revenues</HeadCell>
                <HeadCell iconType="help" onHelpIconClick={() => onHelpIconClick("Gross Margins")}>Gross Margins</HeadCell>
              </Fragment>
            }
            {
              (round < 3 || round >= 4) &&
              <HeadCell iconType="help" onHelpIconClick={() => onHelpIconClick("Share Price")}>Share Price</HeadCell>
            }
            {
              round >= 3 &&
              <Fragment>
                <HeadCell onHelpIconClick={() => onHelpIconClick("ROE")}>ROE</HeadCell>
                <HeadCell onHelpIconClick={() => onHelpIconClick("ROA")}>ROA</HeadCell>
              </Fragment>
            }
            {
              round >= 4 &&
              <HeadCell onHelpIconClick={() => onHelpIconClick("EPS")}>EPS</HeadCell>
            }
          </Row>
        </Thead>
        <TBody>
          {financialTargets.map((item, index) => (
            <Row key={`financial-targets-row-${index}`} isBody>
              <BodyCell
                alignText="center"
                cellSize="small"
                backgroundVariant="default"
              >
                {item.round_number}
              </BodyCell>
              {
                round < 3 &&
                <BodyCell
                  backgroundVariant={getBackgroundVariant(
                    item.market_share,
                    item.round_number,
                    round
                  )}
                >
                  {item.market_share > 0
                    ? `${decimalsRound(item.market_share * 100, 2)}%`
                    : "--"}
                </BodyCell>
              }
              {
                round <= 3 &&
                <Fragment>
                  <BodyCell
                    backgroundVariant={getBackgroundVariant(
                      item.net_revenues,
                      item.round_number,
                      round
                    )}
                  >
                    {item.net_revenues > 0
                      ? `$${decimalsRound(item.net_revenues / 1000000, 2)}M`
                      : "--"}
                  </BodyCell>
                  <BodyCell
                    backgroundVariant={getBackgroundVariant(
                      item.gross_margin,
                      item.round_number,
                      round
                    )}
                  >
                    {item.gross_margin > 0
                      ? `${decimalsRound(item.gross_margin * 100, 2)}%`
                      : "--"}
                  </BodyCell>
                </Fragment>
              }
              {
                (round < 3 || round >= 4) &&
                <BodyCell
                  backgroundVariant={getBackgroundVariant(
                    item.stock_price,
                    item.round_number,
                    round
                  )}
                >
                  {item.stock_price > 0
                    ? `$${decimalsRound(item.stock_price, 2)}`
                    : "--"}
                </BodyCell>
              }
              {
                round >= 3 &&
                <Fragment>
                  <BodyCell
                    backgroundVariant={getBackgroundVariant(
                      item.roe,
                      item.round_number,
                      round
                    )}
                  >
                    {item.roe > 0 ? `${decimalsRound(item.roe * 100, 2)}%` : "--"}
                  </BodyCell>
                  <BodyCell
                    backgroundVariant={getBackgroundVariant(
                      item.roa,
                      item.round_number,
                      round
                    )}
                  >
                    {item.roa > 0 ? `${decimalsRound(item.roa * 100, 2)}%` : "--"}
                  </BodyCell>
                </Fragment>
              }
              {
                round >= 4 &&
                <BodyCell
                  backgroundVariant={getBackgroundVariant(
                    item.earnings_per_share,
                    item.round_number,
                    round
                  )}
                >
                  {item.earnings_per_share > 0
                    ? `$${decimalsRound(item.earnings_per_share, 2)}`
                    : "--"}
                </BodyCell>
              }
            </Row>
          ))}
        </TBody>
      </ResponsiveTable>
    </TableWrapper>
  );
};

export default FinancialTargets;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/FinancialTargets.js